export interface Dictionary {
  id: number;
  createdAt: number;
  updatedAt: number;
  isDeleted: boolean;
  name: string;
  description: string;
  avatar: string;
  type: DictionaryType;
}

export enum DictionaryType {
  ReviewSample = "REVIEW_SAMPLE", //Mẫu nội dung review
}
